module.exports = __webpack_public_path__ + "static/media/ligretto_logo.288b52a5.png";